<template>
  <DataTable :data-model="'templates'"
             :display-name-plural="$t('entities.Template.Plural')"
             :display-name-singular="$t('entities.Template.SingularCs')"
             :permission-name="'Templates'"
             :exclude-fields="['id']">
    <template #cell(risk)="row">
      <p :style="'color:'+colors[row.item.risk]">
        {{ $t('TemplateRisk.'+row.item.risk) }}
      </p>
    </template>
  </DataTable>
</template>
<script>
import DataTable from '@components/admin/DataTable';

export default {
  components: {
    DataTable
  },
  data() {
    return {
      colors: {
        1: '#2ECC40',
        2: '#FF851B',
        3: '#FF4136',
        4: '#0074D9'
      }
    };
  }
};
</script>
<style scoped></style>
